import React from 'react';
import DOMPurify from 'dompurify';
import styles from './FormSteps.module.css';

const StepOne = ({ formData, handleInputChange, errors }) => {
  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  };

  const handleSanitizedInputChange = (e) => {
    const sanitizedValue = DOMPurify.sanitize(e.target.value);
    handleInputChange({
      target: {
        name: e.target.name,
        value: sanitizedValue,
      },
    });
  };

  return (
    <div className={styles.step}>
      <h2 className={styles.stepOneHeading}>Step 1: Your Information</h2>
      
      <div className={styles.formGroup}>
        <label htmlFor="name" className={styles.label}>
          Full Name <span className={styles.required}>*</span>
        </label>
        <input
          id="name"
          className={`${styles.input} ${styles.narrowInput} ${errors.name ? styles.inputError : ''}`}
          type="text"
          name="name"
          value={formData.name}
          onChange={handleSanitizedInputChange}
          required
          onKeyDown={handleKeyDown}
          aria-describedby={errors.name ? "name-error" : undefined}
          aria-invalid={!!errors.name}
        />
        {errors.name && (
          <p id="name-error" className={styles.errorMessage}>
            {errors.name}
          </p>
        )}
      </div>

      <div className={styles.formGroup}>
        <label htmlFor="email" className={styles.label}>
          Email Address <span className={styles.required}>*</span>
        </label>
        <input
          id="email"
          className={`${styles.input} ${styles.narrowInput} ${errors.email ? styles.inputError : ''}`}
          type="email"
          name="email"
          value={formData.email}
          onChange={handleSanitizedInputChange}
          required
          onKeyDown={handleKeyDown}
          aria-describedby={errors.email ? "email-error" : undefined}
          aria-invalid={!!errors.email}
        />
        {errors.email && (
          <p id="email-error" className={styles.errorMessage}>
            {errors.email}
          </p>
        )}
      </div>

      <div className={styles.formGroup}>
        <label htmlFor="phone" className={styles.label}>
          Phone Number
        </label>
        <input
          id="phone"
          className={`${styles.input} ${styles.narrowInput} ${errors.phone ? styles.inputError : ''}`}
          type="tel"
          name="phone"
          placeholder="(123) 456-7890"
          value={formData.phone}
          onChange={handleSanitizedInputChange}
          onKeyDown={handleKeyDown}
          aria-describedby={errors.phone ? "phone-error" : undefined}
          aria-invalid={!!errors.phone}
        />
        {errors.phone && (
          <p id="phone-error" className={styles.errorMessage}>
            {errors.phone}
          </p>
        )}
      </div>

      <div className={styles.formGroup}>
        <label htmlFor="projectDescription" className={styles.label}>
          Project Description <span className={styles.required}>*</span>
        </label>
        <textarea
          id="projectDescription"
          className={`${styles.textarea} ${errors.projectDescription ? styles.inputError : ''}`}
          name="projectDescription"
          value={formData.projectDescription}
          onChange={handleSanitizedInputChange}
          required
          onKeyDown={handleKeyDown}
          aria-describedby={errors.projectDescription ? "project-description-error" : undefined}
          aria-invalid={!!errors.projectDescription}
          rows={5}
        />
        {errors.projectDescription && (
          <p id="project-description-error" className={styles.errorMessage}>
            {errors.projectDescription}
          </p>
        )}
      </div>
    </div>
  );
};

export default StepOne;
